<template>

  <div>

    <h2>{{$t('title.accesses-for')}} | Mobile: {{ mobile.contact_name }}</h2>

    <single-access
      :access-holders="accessHolders"
      :unprocessed-accesses="unprocessedAccesses"
      :columns="['controllerName', 'name']"
      :mobile-id="mobileId" />

  </div>

</template>

<script>
import SingleAccess from './SingleAccess'
import findAll from 'service/findAll'
import findOne from 'service/findOne'

export default {
  name: 'single-mobile-access',
  computed: {
    mobileId () {
      return this.$route.params.id
    },
    accessHolders () {
      return this.switches
        .map(s => ({
          ...s,
          access: (this.mobile.mobileAccesses || []).find(a => a.switch_id === s.id)
        }))
        .filter(s => s.usage === 'entry-point')
    }
  },
  components: { SingleAccess },
  mixins: [
    findAll('switches'),
    findOne('mobiles', 'mobile', function () { return this.mobileId }),
    findAll('pending-mobile-accesses', 'unprocessedAccesses', {
      filter (access) {
        return access.mobile_id === this.mobileId
      },
      map (access) {
        return { ...this.switches.find(s => s.id === access.switch_id), access }
      }
    })
  ]
}
</script>



// WEBPACK FOOTER //
// SingleMobileAccess.vue?fb52aa2e